import { ICategoryInfo } from '@gem/models/commonModel';
import { logger } from '@gem/modules/logger';
import dateService from '@gem/services/date-service';

import { getUserLanguage } from 'UTILS/getUserLanguage';

// ONE DAY
const CATEGORY_CACHE_SAVE_TS = 24 * 60 * 60 * 1000;

interface IGetAllCategoriesInfoRequest {
  readonly locale: string;
  readonly type: string;
}

interface ICategoriesCache {
  readonly locale: string;
  readonly categories: ICategoryInfo[];
  readonly loadTs: number;
}

let categoriesCache: ICategoriesCache | null = null;

// Needs Bff implementation
async function request(data: IGetAllCategoriesInfoRequest): Promise<ICategoryInfo[]> {
  try {
    return [];
  } catch (error) {
    logger.get('API').error('search.getAllCategoriesInfo', error);
    return [];
  }
}

const loadCategories = async (): Promise<void> => {
  const locale = getUserLanguage();

  const categories = await request({
    locale,
    type: 'group',
  });

  categoriesCache = {
    locale,
    loadTs: dateService.now().valueOf(),
    categories: categories.sort(
      (categoryA, categoryB) => parseInt(categoryA.order, 10) - parseInt(categoryB.order, 10)
    ),
  };
};

const isCacheInvalid = (): boolean => {
  const locale = getUserLanguage();
  return (
    !categoriesCache ||
    categoriesCache.locale !== locale ||
    dateService.now().valueOf() - categoriesCache.loadTs > CATEGORY_CACHE_SAVE_TS
  );
};

export const getAllCategoriesInfo = async (): Promise<ICategoryInfo[]> => {
  if (isCacheInvalid()) {
    await loadCategories();
  }

  return categoriesCache?.categories || [];
};
